<form>
  <title mat-dialog-title>{{ 'map.drawing.linkToIncident' | t }}</title>
  <mat-dialog-content>
    <div class="form-container">
      <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      <button
        mat-icon-button
        type="button"
        class="addNewCaseButton"
        (click)="addNewIncident()"
        color="accent"
        [matTooltip]="'incidentManagement.dialogs.addMedia.createNewCase' | t"
        matTooltipPosition="left"
      >
        <sn-icon>add</sn-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" (click)="cancel()" type="button">{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" [disabled]="form.invalid" (click)="onSubmit()">
      {{ 'common.select' | t }}
    </button>
  </mat-dialog-actions>
</form>
